module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "object",
    staticClass: "object",
    style: ({
      'background-image': 'url(' + require('../../assets/images/website/' + _vm.image) + ')'
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-346d0944"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/website/PngSequence.vue
// module id = 703
// module chunks = 64